/**
 * Parcelamento do plano anual no UnixCard (POST /ativacao/solicitar com
 * `id_plano_promocao: 2` e `numero_parcelas`).
 *
 * A API aceita de 1 a 12 parcelas e calcula a parcela como
 * `round(total / n, 2)` (UnixBankService). O cálculo aqui é feito em centavos
 * para dar o mesmo resultado: em ponto flutuante, `Math.round(x * 100)`
 * erra casos de meio centavo que o `round` do PHP acerta.
 */

/** Máximo de parcelas no UnixCard, que também é o padrão do seletor. */
export const PARCELAS_UNIXCARD = 12

export interface OpcaoParcela {
  n: number
  valor: number
}

export function valorParcela(total: number, n: number): number {
  const centavos = Math.round(total * 100)
  return Math.round(centavos / n) / 100
}

export function opcoesParcelas(total: number, maximo: number = PARCELAS_UNIXCARD): OpcaoParcela[] {
  return Array.from({ length: maximo }, (_, index) => {
    const n = index + 1
    return { n, valor: valorParcela(total, n) }
  })
}

/** "R$ 26,60", no mesmo formato dos outros valores do link de vendas. */
export function formatarReais(valor: number): string {
  return `R$ ${valor.toFixed(2).replace('.', ',')}`
}
